import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
import Vuex from 'vuex'
import auth from './modules/auth'
import dashboard from './modules/dashboard'
import contact from './modules/contact'
import about from './modules/about'
import seo from './modules/seo'
import admin from './modules/admin'
import language from './modules/language'
import support from './modules/support'
import orders from './modules/orders'
import currency from './modules/currency'
import settings from './modules/settings'
import cookie from './modules/cookie'
import pages from './modules/pages'
import role from './modules/role'
import certificate from './modules/certificate'
import permissions from './modules/permissions'
import city from './modules/Area/city'
import region from './modules/Area/region'
import country from './modules/Area/country'
import continent from './modules/Area/continent'
import sight from './modules/Area/sight'
import faq from './modules/faq'
import user from './modules/user'
import companyService from './modules/Hotel/company_service'
import hotel from './modules/Hotel/hotel'
import room from './modules/Hotel/room'
import roomType from './modules/Hotel/room_type'
import discount from './modules/Hotel/discount'
import creditCard from './modules/credit_card'
import facility from './modules/Hotel/facility'
import facilityCategory from './modules/Hotel/facilityCategory'
import roomBase from './modules/Hotel/room_base'
import article from './modules/Article/article'
import tag from './modules/Article/tag'
import district from './modules/Area/district'
import articleCategory from './modules/Article/article_category'
import contactUs from './modules/contact_us'
import booking from './modules/booking'
import paymentRequisite from './modules/payment_requisite'
import application from './modules/application'
import covid from './modules/covid'
import transaction from './modules/transaction'
import withdrawal from './modules/withdrawal'
import serviceOrder from './modules/service_order'

Vue.use(Vuex)

const dataState = createPersistedState({
  paths: ['auth']
})

export default new Vuex.Store({
  modules: {
    user,
    transaction,
    covid,
    contactUs,
    paymentRequisite,
    application,
    booking,
    discount,
    creditCard,
    seo,
    facility,
    facilityCategory,
    district,
    article,
    tag,
    articleCategory,
    faq,
    companyService,
    roomBase,
    roomType,
    room,
    hotel,
    role,
    city,
    region,
    country,
    sight,
    continent,
    permissions,
    certificate,
    settings,
    currency,
    orders,
    support,
    language,
    admin,
    auth,
    contact,
    about,
    cookie,
    pages,
    withdrawal,
    dashboard,
    serviceOrder
  },
  plugins: [dataState]
})
